import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { downloadBlob } from '@/_shared/helpers/download';
import { GenericGet } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_REPORTS_ASSESSMENT_EXPORT_PATH_KEY } from '@/swagger/constants/reports-keys';
import { API_GET_REPORT_ASSESSMENT_EXPORT, KEY_GET_REPORT_ASSESSMENT_EXPORT } from '../constants';
import { MOCK_RESPONSE_GET_REPORT_ASSESSMENT_EXPORT } from '../mocks';
import { CallResponseGetReportAssessmentExport } from '../types';

type RequestGetReportAssessmentExportPath = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_REPORTS_ASSESSMENT_EXPORT_PATH_KEY
>['request']['path'];

export type CallParamsGetReportAssessmentExport = Omit<
  RequestGetReportAssessmentExportPath,
  'organizationId'
> & {
  fileName?: string;
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallErrorGetReportAssessmentExport = GenericApiError;

type CallSelectorsGetReportAssessmentExport = unknown;

let fileName: string | undefined;

export const getReportAssessmentExportCall = createGeneralCall<
  CallParamsGetReportAssessmentExport,
  CallResponseGetReportAssessmentExport,
  CallErrorGetReportAssessmentExport,
  CallSelectorsGetReportAssessmentExport
>({
  id: KEY_GET_REPORT_ASSESSMENT_EXPORT,
  url:
    ({ payload: { fileName: givenFileName = 'reporting-assessment' } }) =>
    state => {
      fileName = givenFileName || undefined;
      const org = getCurrentOrganization(state);
      return API_GET_REPORT_ASSESSMENT_EXPORT(org as unknown as string);
    },
  method: 'get',
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_REPORT_ASSESSMENT_EXPORT : undefined,
  responseExtractor: 'blob',
  responseMapper: ({ response: blob }) => {
    downloadBlob(blob, fileName);
  },
});
